import { IDocumentModel } from "./../../interfaces/document-model";
import { DocumentEvents } from "./../../helpers/document-events";
import { IParagraphFilterDefinition } from "./../../interfaces/document-request-options";
import { QueryComponentsCollection } from "./../../../search/collections/query-components";
import { ParagraphFilterModel } from "./../paragraph-filter";
import { FulltextTabState } from "./fulltext-state";
import {prop} from "../../../decorators/property";

export enum FullTextMode {
    Text,
    Pdf
}

export class JudgmentTabState extends FulltextTabState {

    public static highlightColors: string[] = ["blue", "yellow", "pink", "green"];
    @prop() public Highlighting = false;
    @prop() public HighlightedTerms: Element[] = new Array<Element>();
    @prop() public ParagraphFilters: Backbone.Collection<ParagraphFilterModel> = new Backbone.Collection<ParagraphFilterModel>();
    @prop() public ShowPowerPara = false;
    @prop() public ShowAllQuotes = false;
    @prop() public ScrollLock = false;
    @prop() public ParagraphNumber: number;

    /** Refresh the paragraph filters and re-trigger the CICEngaged event on the docmodel */
    public refreshParagraphFilters(docModel: IDocumentModel) {
        const filters = (this.ParagraphFilters as any).clone();
        this.ParagraphFilters.reset();
        filters.each((filter: ParagraphFilterModel) => {
            this.ScrollLock = true;
            this.ParagraphFilters.add(filter);
            docModel.trigger(DocumentEvents.CICEngaged, {
                Class: "active-" + filter.get("color"),
                Id: filter.get("id")
            });
        });
        this.ScrollLock = false;

    }

    public addOrRemoveParagraphFilter(filterDef: IParagraphFilterDefinition, cited: Backbone.Collection<any>): string {
        const filters = this.ParagraphFilters;
        const existing = filters.get(filterDef.id);
        if (existing) {
            this.ParagraphFilters.remove((filterDef.id as any));
            return "";
        } else {
            return this.addParagraphFilter(filterDef, cited);
        }
    }

    public addParagraphFilter(filterDef: IParagraphFilterDefinition, cited: Backbone.Collection<any>): string {
        const existingColors: string[] = [];
        const filters = this.ParagraphFilters;
        const existing = filters.get(filterDef.id);
        if (existing) {
            // If this filter already exists, remove then readd it so all the triggers work properly
            this.ParagraphFilters.remove(filterDef.id as any);
        }

        if (filters.length === JudgmentTabState.highlightColors.length) {
            return "";
        }

        this.ShowAllQuotes = false;
        this.ShowPowerPara = false;

        filters.each((filter) => {
            existingColors.push(filter.get("color"));
        });

        const newColor = _.difference(JudgmentTabState.highlightColors, existingColors)[0];
        const consideredItem = cited.where({ Id: filterDef.id })[0];
        if (!consideredItem) {
            return;
        }

        filters.add(new ParagraphFilterModel(
            {
                id: filterDef.id,
                color: newColor,
                count: filterDef.count,
                name: consideredItem.get("Title"),
                materialtype: consideredItem.get("MaterialType")
            }));
        return "active-" + newColor;

    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/desktop/models/tabs/judgment-tab-state.ts